import React from "react";
import { ArrowRight, Search } from "lucide-react";
import { finalCta } from "../content/landingContent";
import { CtaButton } from "./CtaButton";
import { AssetPlaceholder } from "./AssetPlaceholder";
import { Reveal } from "./Reveal";
import { useContentField, useLinks } from "../lib/useContent";
import { trackLead, trackViewContent } from "../lib/metaPixel";
import qrMotorpro from "../assets/brand/qr-motorpro.png";

export const FinalCTA: React.FC = () => {
  const links = useLinks();
  const title = useContentField("finalCta.title", finalCta.title);
  const text = useContentField("finalCta.text", finalCta.text);
  const ctaPrimary = useContentField("finalCta.ctaPrimary", finalCta.ctaPrimary);
  const ctaSecondary = useContentField("finalCta.ctaSecondary", finalCta.ctaSecondary);
  const qrCaption = useContentField("finalCta.qrCaption", finalCta.qrCaption);
  const comingSoon = useContentField("finalCta.comingSoon", finalCta.comingSoon);
  return (
    <section
      id="contacto"
      data-testid="final-cta-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-neutral-200 bg-motor-mist p-8 sm:p-12 lg:p-16 grid lg:grid-cols-[1fr_auto] gap-12 items-center">
          <Reveal>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-motor-ink leading-tight">
              {title}
            </h2>
            <p className="mt-5 text-base text-neutral-600 max-w-lg leading-relaxed">
              {text}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3.5">
              <CtaButton
                href={links.appUrl}
                onClick={() => trackLead("final_cta_download")}
                size="lg"
                testId="final-cta-download-button"
                icon={<ArrowRight className="h-4 w-4" />}
              >
                {ctaPrimary}
              </CtaButton>
              <CtaButton
                href={links.exploreUrl}
                onClick={() => trackViewContent("final_cta_explore")}
                variant="outline"
                size="lg"
                testId="final-cta-explore-button"
                icon={<Search className="h-4 w-4" />}
              >
                {ctaSecondary}
              </CtaButton>
            </div>
            <p className="mt-5 text-xs text-neutral-400">{comingSoon}</p>
          </Reveal>

          <Reveal variant="scale" delay={0.15} className="flex flex-col items-center gap-3">
            <AssetPlaceholder
              resourceKey="final-cta.qr"
              fallbackSrc={qrMotorpro}
              variant="qr"
              label="Código QR"
              alt="Código QR MotorPRO Autos"
              hint="Espacio editable"
              className="w-40 sm:w-44"
            />
            <p className="text-xs text-neutral-500 max-w-[180px] text-center">{qrCaption}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
